<template>
    <q-table
            :columns="columns"
            :rows="userClients"
            selection="multiple"
            :selected="selected"
            :selected-rows-label="selectedLabel"
            :loading="isLoading"
            :rows-per-page-options="[0]"
            flat
            @update:selected="$emit('update:selected', $event)">
        <template v-slot:body-cell-assignedAt="props">
            <q-td :props="props">
                <humanize-time :time="props.value" />
            </q-td>
        </template>
        <template v-slot:no-data>
            <message v-show="!isLoading" class="full-width">
                User is not assigned to any clients.
            </message>
        </template>
    </q-table>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { UserClient } from '@/type';
import { HasTaskMixin } from '@/mixins';
import HumanizeTime from '@/components/HumanizeTime.vue';
import { name as clientNameFilter } from '@/client/client-filter';
import repository from '@/user-client/userClientRepository';
import Message from '@/components/message/Message.vue';

interface Data {
  task: Promise<UserClient[]>|null,
  columns: object[],
  userClients: UserClient[],
}

export default defineComponent({
  emits: ['update:selected'],
  mixins: [HasTaskMixin],
  props: {
    userId: {
      type: Number,
      required: true,
    },
    selected: {
      type: Array as () => UserClient[],
      default() {
        return [];
      },
    },
    keyword: String,
  },
  data(): Data {
    return {
      task: null,
      columns: [
        {
          name: 'name',
          label: 'Name',
          field: (uc: UserClient) => clientNameFilter(uc.client),
          align: 'left',
        },
        {
          name: 'fileRefNo',
          label: 'File Ref No.',
          field: (uc: UserClient) => uc.client.fileRefNo,
          align: 'left',
        },
        {
          name: 'assignedAt',
          label: 'Assigned',
          field: (uc: UserClient) => uc.assignedAt,
          align: 'left',
        },
      ],
      userClients: [],
    };
  },
  watch: {
    userId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
    keyword: 'load',
  },
  methods: {
    selectedLabel(): string {
      const count = this.selected.length;
      const total = this.userClients.length;
      return `${count} client${(count === 1) ? '' : 's'} selected of ${total}`;
    },
    load() {
      this.task = repository.findAll(this.userId, {
        keyword: this.keyword,
      });
      this.task.then((userClients: UserClient[]) => {
        this.userClients = userClients;
      });
    },
    removeItem(userClient: UserClient) {
      const index = this.userClients.findIndex(uc => uc.id === userClient.id);
      if (index >= 0) {
        this.userClients.splice(index, 1);
      }
    },
  },
  components: {
    Message,
    HumanizeTime,
  },
});
</script>
